import { Chart, Point, Interval, DonutChart, Axis, Coordinate, Legend } from "bizcharts";

export const AdminJobsChart = ({ data, name }) => (
    <div>
        <h4 className="text-center pt-4 mt-4 mb-0">{name}</h4>
        <Chart data={data} padding={[60]} autoFit height={400}>
            <Interval position="key*count" />
            <Point position="key*count" label="count" />
        </Chart>
    </div>
);

export const SLAJobsChart = ({ data, name, avgTime }) => (
    <div>
        <h4 className="text-center pt-4 mt-4 mb-0">{name}</h4>
        <DonutChart data={data} autoFit height={350} padding={[40, 0, 0, 0]} legend={false}
            angleField="slaPercentage"
            colorField="timeElapsed"
            statistic={{
                title: {
                    customHtml: () => 'Average Time',
                    style: {paddingBottom: '5px'}
                },
                content: {
                    customHtml: () => avgTime,
                    style: {fontSize: '18px', marginTop: '8px', fontWeight: 400}
                }
            }}
            pieStyle={{ stroke: "white", lineWidth: 5 }}
        />
    </div>
);

export const RecentJobs = ({ data, name }) => (
    <div>
        <h4 className="text-center pt-4 mt-4 mb-0">{name}</h4>
        <Chart height={400} data={data} autoFit>
            <Coordinate type="theta" radius={0.8} />
            <Axis visible={false} />
            <Interval
                position="count"
                adjust="stack"
                color="key"
                style={{
                    lineWidth: 1,
                    stroke: '#fff'
                }}
                label={['count', {
                    content: (data) => {
                        return `${data.count}`;
                    },
                }]}
            />
        </Chart>
    </div>
);

export const HorizontalBarChart = ({ data, name }) => (
    <div>
        <h4 className="text-center pt-4 mt-4 mb-0">{name}</h4>
        <Chart data={data} height={550} width={400} padding={[0,0,0,90]} autoFit>
            <Coordinate transpose />
            <Axis name="key" />
            <Axis name="value" visible={false} />
            <Interval  position="key*value" 
                label={['value', {
                    offset: -15
                }]} 
            />
        </Chart>
    </div>
);

export const Metrics = ({ data, name }) => {
    return (
        <div>
            <h4 className="text-center py-5 mt-4 mb-0">{name}</h4>
            <Chart height={400} data={data} autoFit>
                <Coordinate type="polar" innerRadius={0.2} />
                <Axis visible={false} />
                <Legend visible={false} />
                <Interval position="staff*count" adjust="stack" color="staff" element-highlight
                    style={{
                        lineWidth: 1,
                        stroke: '#fff'
                    }}
                    label={['staff', {
                        offset: -15
                    }]}
                />
            </Chart>
        </div>
    );
};